/**
 * i18n Configuration
 *
 * Sets up react-i18next with Swedish and English translations.
 * Defaults to English as the primary language.
 *
 * @version 1.0.0
 */

import i18n from 'i18next';
import {initReactI18next} from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import en from './translations/en.json';
import sv from './translations/sv.json';

void i18n
  .use(LanguageDetector) // Detect user language from browser/localStorage
  .use(initReactI18next) // React integration
  .init({
    resources: {
      en: { translation: en },
      sv: { translation: sv },
    },
    fallbackLng: 'en', // Default to English
    lng: 'en', // Initial language
    supportedLngs: ['sv', 'en'], // Only support Swedish and English
    defaultNS: 'translation',
    ns: ['translation'],
    interpolation: {
      escapeValue: false, // React already escapes values
    },
    detection: {
      order: ['localStorage', 'querystring', 'navigator'],
      caches: ['localStorage'],
      lookupLocalStorage: 'i18nextLng',
      // Convert detected language to supported format
      convertDetectedLanguage: (lng: string) => {
        // Normalize to 'sv' or 'en'
        const normalized = lng.toLowerCase().split('-')[0];
        if (normalized === 'sv' || normalized === 'svenska') return 'sv';
        if (normalized === 'en' || normalized === 'english') return 'en';
        // Default to English for unsupported languages
        return 'en';
      },
    },
    react: {
      useSuspense: false, // Disable suspense for better compatibility
    },
  });

export default i18n;
